import { ColorAddiCompFiveLighten1, ColorAddiGrayLighten1 } from '@addi/foundation/dist/web/colors';
import { FontAddiWeightExtraBold, FontAddiWeightRegular } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
import { PrimaryFont } from '../../components/typographies';
import styled from 'styled-components';
export const FooterContainer = styled.div `
    display: flex;
    align-items: center;
    padding: 1rem;
`;
export const FooterText = styled.span `
    ${PrimaryFont}
    color: ${ColorAddiGrayLighten1};
    font-weight: ${FontAddiWeightRegular};
    font-size: ${SizeAddiFontXSmall};
    padding-right: 5px;
`;
export const AddiFlashLogo = styled.img `
    width: 18px;
    height: 18px;
`;
export const AddiFlashText = styled.span `
    ${PrimaryFont}
    color: ${ColorAddiCompFiveLighten1};
    font-weight: ${FontAddiWeightExtraBold};
    font-size: ${SizeAddiFontXSmall};
`;
//# sourceMappingURL=addi-flash-footer.styled.js.map